// import AirDatepicker from 'air-datepicker';
import AirDatepicker from './air-datepicker';
import $ from "jquery";





const someFun = function(that) {

	const cells = that.find('.-selected-');

	cells.each(function () {
		if (!$(this).next('.air-datepicker-cell').hasClass('-selected-')) {
			$(this).addClass('air-datepicker-cell--last')
		}
	})
};

$(document).ready(function() {
	$('.jsDatePicker').each(function () {

		const that = $(this);

		const dates = $(this).data('dates');
		const tooltips = $(this).data('tooltips');

		new AirDatepicker(this, {
			multipleDates: true,
			selectedDates: dates,
			onRenderCell(some) {

				// месяц
				let relMonth = some.date.getMonth()+1;
				if (relMonth < 10) {
					relMonth = `0${relMonth}`;
				}

				// день
				let relDay = some.date.getDate();
				if (relDay < 10) {
					relDay = `0${relDay}`;
				}

				// индекс из массива с датами
				const dateIndex = dates.indexOf(`${some.date.getFullYear()}-${relMonth}-${relDay}`);

				// html в ячейку
				let realHtml;

				if (dateIndex > (-1)) {
					realHtml = `${some.date.getDate()} <div class="custom-tooltip custom-tooltip--tail--bottom--center"><div class="custom-tooltip__inner"><div class="custom-tooltip__desc"><p>${tooltips[dateIndex]}</p></div></div></div>`
				} else {
					realHtml = `<div> ${some.date.getDate()}</p> </div>`
				}


				setTimeout(function () {
					someFun(that)
				},150)

				return {
					html: realHtml,
					disabled: true,
				}
			},
		});

	});
});





